export function errorHandler(error) {
  console.error(error.message);
}
